<template>
  <div>
    <Breadcrumb :title="'Investment Information'"></Breadcrumb>
    <InvestmentForm
      :ref="'InvestmentForm'"
      :InvestmentInfo="InvestmentJSON"
      :InvestmentModalLabel="modalConfig"
      @SaveComplete="refreshGrid"
    ></InvestmentForm>
    <div>
      <BaseSearchBar :config="search" @keyupSearch="filterGrid"></BaseSearchBar>
    </div>
    <div class="btnDiv">
      <BaseToolBar :config="ToolbarConfig" @buttonClicked="toolbarOnClick"></BaseToolBar>
    </div>
    <div>
      <BaseGrid
        :config="GridConfig"
        :excelExport="excelExport"
        :mode="'editform'"
        @EditItem="EditInvestment"
        @DeleteItem="DeleteItemfromGrid"
        :data="InvestmentData"
        @AttachItem="InvestmentAttachment"
      ></BaseGrid>
    </div>
    <InvestmentDocumentDropoffForm
      ref="investmentDocument"
      :docModalConfig="docModalConfig"
      :filterCondition="filterCondition"
      :transactionRecord="selectedInvestment"
    ></InvestmentDocumentDropoffForm>
  </div>
</template>

<script>
import $ from "jquery";
import { GridConfig, ToolbarConfig } from "./InvestmentInfoConfig.js";
import BaseModelInvestment from "@/models/BaseModelInvestment.js";
import BaseModelInvestmentValuation from "@/models/BaseModelInvestmentValuation.js";
import Breadcrumb from "@/components/layout/Breadcrumb.vue";
import BaseGrid from "@/components/base/BaseGrid.vue";
import BaseModelInputControl from "@/models/BaseModelInputControl.js";
import apiUtil from "@/services/apiUtil.js";
import funcUtil from "@/services/funcUtil.js";
import BaseSearchBar from "@/components/base/BaseSearchBar.vue";
import BaseToolBar from "@/components/base/BaseToolbar.vue";
import toolbarUtility from "@/services/toolbarUtility.js";
import InvestmentForm from "@/components/forms/InvestmentForm.vue";
import BaseModelUnitClass from "@/models/BaseModelUnitClass.js";
import BaseModelProgram from "@/models/BaseModelProgram.js";
import { mapGetters, mapActions, mapState } from "vuex";

import InvestmentDocumentDropoffForm from "@/components/forms/InvestmentDocumentDropoffForm.vue";

export default {
  name: "InvestmentEvent",
  mixins: [apiUtil, funcUtil, toolbarUtility],
  components: {
    Breadcrumb,
    BaseGrid,
    BaseSearchBar,
    BaseToolBar,
    InvestmentForm,
    InvestmentDocumentDropoffForm
  },
  computed: {
    ...mapGetters("getModule", [
      "withFilter",
      "getAllItemFilter",
      "getLocalInputControls"
    ]),
    ...mapState("postModule", ["response"])
  },
  data: function() {
    return {
      GridConfig: GridConfig,
      grid: $("#" + GridConfig.grid.gridId).data("kendoGrid"),
      search: {
        SearchData: ""
      },
      InvestmentGridId: "InvestmentGrid",
      InvestmentMasterData: {},
      ToolbarConfig: ToolbarConfig,
      BaseModelInvestment: BaseModelInvestment,
      BaseModelInvestmentValuation: BaseModelInvestmentValuation,
      BaseModelUnitClass: BaseModelUnitClass,
      BaseModelProgram: BaseModelProgram,
      BaseModelInputControl: BaseModelInputControl,
      modalConfig: {
        modalName: "",
        modalAddorEdit: ""
      },
      InvestmentJSON: {
        parent: {},
        children: {}
      },
      // InvestmentAddJSON: {
      //Id: "",
      // BusinessEvent:"",
      // ProgramId:"",
      // ReceiverId:"",
      // ProgramTitle:"",
      // ReceiverFullName:"",
      // UnitClass:"",
      // UnitType:"",
      // UnitPool:"",
      // Unit:"",
      // TransactionDate:"",
      // },
      InvestmentEditJSON: {
        parent: {
          Id: "",
          InvestmentID: "",
          Title: "",
          InvestmentGroup: "",
          StatementOrder: "",
          Note: "",
          ShowOnFMVS: "",
          HideNumberOnFMVS: ""
        },
        children: {
          InvestmentValuation: []
        }
      },
      InvestmentData: [],
      InvestmentValuationData: [],
      InvestmentInfoData: [],
      dropdowns: {
        TaxPeriod: { model: "", dataSource: [] }
      },
      // Document dropoff modal
      docModalConfig: {
        modalName: "Investment Documents",
        modalIdandRef: "docModal",
        isFooter: false
      },
      // Filter condition for Document dropoff modal
      filterCondition: {
        filter: "",
        limit: 500
      },
      selectedInvestment: {}
    };
  },
  mounted() {
    const self = this;

    if (Object.keys(this.$route.query)[0] == "InitailIssuace") {
      $("#btnAddInvestment").click();
      $("#backTo").removeClass("d-none");
    }
    //changes for Toolbar
    //self._loadGridSettings(self.InvestmentGridId);
    // $("#dropdownPeriod").bind("change",self.PeriodChangedEventHandler);

    //self.getInputControls();
    self.getBaseGridData();
    //get the data from Investment and InvestmentValuation table. Combine to form the Investment Info Grid
    self.getCombinedInvestmentData();

    //bind databound event to grid
    const grid = $("#InvestmentGrid").data("kendoGrid");
    grid.bind("dataBound", self.UpdateInvestmentMasterData);
    // grid.dataSource.fetch();
  },
  methods: {
    ...mapActions("postModule", ["DeleteItem", "DeleteAllFiles"]),

    async getBaseGridData() {
      await this.getInputControls();
      this._loadGridSettings(this.InvestmentGridId);
    },

    async getInputControls() {
      let self = this;
      let response = self.getLocalInputControls(
        self.BaseModelInputControl.list
      );
      // await self._getInputControls().then(response => {
      // let response = self.withFilter("InputControl");
      // console.log(response);
      Object.keys(self.dropdowns).forEach(key => {
        self.dropdowns[key].dataSource = response[key];
        // self.dropdowns[key].filter = self._setDropdownFilter(response[key]);
      });
    },

    getCombinedInvestmentData: function() {
      const self = this;
      // self.getAllItemFilter({
      //   Investment: { config: BaseModelInvestment },
      //   InvestmentValuation: { config: BaseModelInvestmentValuation }
      // }).then( (response) => {

      // self._getAllItems({
      let response = self.getAllItemFilter({
        Investment: { config: BaseModelInvestment }
      });
      if (response) {
        // console.log('async _getAllItems', response)
        self.InvestmentData = response.Investment;
      }
      // self.getInputControls();
      //   self.PeriodChangedEventHandler();
    },

    UpdateInvestmentMasterData: function(fromFilter, filterMasterData) {
      if (fromFilter == true) {
        this.InvestmentMasterData = filterMasterData;
      } else {
        this.InvestmentMasterData = JSON.parse(
          JSON.stringify(
            $("#InvestmentGrid")
              .data()
              .kendoGrid.dataSource.data()
          )
        );
      }
    },

    toolbarOnClick: function(e) {
      e.preventDefault();
      switch (e.id) {
        case "btnAddInvestment":
          this.AddInvestment();
          window.$("#BaseModal").modal("toggle");
          break;
        case "backTo":
          this.$router.push("/event/initialissuance");
          break;
        // case "btnApproveInvestment":
        //   this.ApproveInvestment();
        //   break;
        case "btnBulkImportUnitInvestmentValuation":
          // this._AlertPopup("Bulk import screen is in progress...");
          this.$router.push("/configuration/investment/upload");
          break;
        case "btnRefresh":
          this.refreshGrid();
          break;
      }
      this._baseToolBarEvents("InvestmentGrid", ...arguments);
    },
    refreshGrid: function() {
      this.getCombinedInvestmentData();
      // $("#InvestmentGrid").data().kendoGrid.dataSource.read();
      // alert("Data Refreshed!");
    },

    filterGrid: function() {
      let self = this;
      // this.ProgramInfoFormJSON = $("#programGrid").data().kendoGrid.dataSource.view()
      // var displayedData = $("#programGrid").data().kendoGrid.dataSource.view()
      //Then stringify it as follows:
      // var displayedDataAsJSON = JSON.stringify(displayedData);
      //alert(displayedDataAsJSON );
      var currentMasterdata = this.InvestmentMasterData;

      let filteredData = this._filterGrid(
        this.InvestmentMasterData,
        this.search.SearchData
      );
      //Filter by a column
      // let filteredData=this._filterGridbyColumn(parentGridData,"StartDate",this.searchData);
      //this.parentdata = filteredData;
      $("#InvestmentGrid")
        .data("kendoGrid")
        .dataSource.data(filteredData);
      this.UpdateInvestmentMasterData(true, currentMasterdata);
    },
    AddInvestment: function() {
      this.modalConfig.modalName = "Add Investment";
      this.modalConfig.modalAddorEdit = "add";
      var InvestmentAddJSON = {
        parent: {
          Id: "",
          InvestmentID: "",
          Title: "",
          InvestmentGroup: "",
          StatementOrder: "",
          Note: "",
          ShowOnFMVS: false,
          HideNumberOnFMVS: ""
        }
        // children:{
        // InvestmentValuation:[],
        // }
      };
      this.$refs.InvestmentForm.IVDeleteItemsArray = [];
      this.$refs.InvestmentForm.pageErrors = [];
      this.InvestmentJSON = InvestmentAddJSON;
      this.$refs.InvestmentForm.assginSelectedHideNumberOnFMVS("");
      this.$refs.InvestmentForm.onChangeShowOnFMVS("add");

      // this.InvestmentAddJSONId = "";
      // this.$refs.ProgramInfo.$refs.refProgramForm.errors.clear();
    },
    EditInvestment: function(e) {
      let self = this;
      e.preventDefault();
      this.modalConfig.modalName = "Edit Investment";
      this.modalConfig.modalAddorEdit = "edit";
      //alert("Edit button clicked from BaseGrid..");
      var gview = window.$("#InvestmentGrid").data("kendoGrid");
      // var dataItem1 = gview.dataItem(window.$(e.currentTarget).closest("tr"));
      var dataItem = JSON.parse(
        JSON.stringify(gview.dataItem(window.$(e.currentTarget).closest("tr")))
      );
      this.$refs.InvestmentForm.IVDeleteItemsArray = [];
      this.$refs.InvestmentForm.pageErrors = [];
      // alert(JSON.stringify(dataItem));
      // self.InvestmentEditJSON.parent = dataItem;
      // self.InvestmentEditJSON.children.InvestmentValuation=[];

      // this._getItems(BaseModelInvestmentValuation, {
      //   filter: "Investment/Id eq " + dataItem.Id
      // }).then(response => {

      //    let response =  this.withFilter(BaseModelInvestmentValuation.list, {filter: "Investment/Id eq " + dataItem.Id});
      // console.log("IV", response);
      // self.InvestmentEditJSON.parent = dataItem;
      self.InvestmentEditJSON.parent.Id = dataItem.Id;
      self.InvestmentEditJSON.parent.Title = dataItem.Title;
      self.InvestmentEditJSON.parent.InvestmentID = dataItem.InvestmentID;
      self.InvestmentEditJSON.parent.InvestmentGroup = dataItem.InvestmentGroup;
      self.InvestmentEditJSON.parent.StatementOrder = dataItem.StatementOrder;
      self.InvestmentEditJSON.parent.Note = dataItem.Note;
      self.InvestmentEditJSON.parent.ShowOnFMVS =
        dataItem.ShowOnFMVS == "Yes" ? true : false;
      self.InvestmentEditJSON.parent.HideNumberOnFMVS =
        dataItem.HideNumberOnFMVS;
      // self.InvestmentEditJSON.children.InvestmentValuation=response;
      self.InvestmentJSON = self.InvestmentEditJSON;
      this.$refs.InvestmentForm.assginSelectedHideNumberOnFMVS(
        dataItem.HideNumberOnFMVS
      );
      this.$refs.InvestmentForm.onChangeShowOnFMVS(
        "edit",
        this.InvestmentJSON.parent.ShowOnFMVS
      );
      console.log("InvestmentJSON", self.InvestmentJSON);
      window.$("#BaseModal").modal("toggle");
      // });
    },
    async DeleteItemfromGrid(e) {
      e.preventDefault();
      const self = this;
      //alert("Delete button clicked from BaseGrid..");
      let message = "";
      let filesToBeDeleted = [];
      let gview = window.$("#InvestmentGrid").data("kendoGrid");
      let dataItem = gview.dataItem(window.$(e.currentTarget).closest("tr"));

      //check for the Investment ID in the Program table if exist then we should not delete
      let ProgramResponse = self.withFilter("Program", {
        filter: "InvestmentId eq " + dataItem.Id
      });
      if (ProgramResponse.length > 0) {
        this._AlertPopup(
          "You cannot delete this Investment, since it has a reference in Program!",
          "warning"
        );
        return;
      }
      //Get the Documents Count for this record
      let filteredDocumentList = self.withFilter("Documents", {
        filter: `BusinessEvent eq 'Investment' and TransactionID eq ${dataItem.Id}`
      });

      if (filteredDocumentList && filteredDocumentList.length > 0) {
        message =
          "By deleting this, you will also delete the corresponding documents related to this.";
        filteredDocumentList.forEach(element => {
          let file = {};
          file.Id = element.Id;
          file.FileName = element.FileName;
          file.FileServerRelativeUrl = element.FileServerRelativeUrl;
          filesToBeDeleted.push(file);
        });
      } else {
        message = "Are you sure you want to delete this record?";
      }

      let result = await this._ConfirmationPopup(message, "DELETE");
      if (result.value) {
        //let loader = this.$loading.show();
        this._APICrudPopup("APICrudpopup");
        //Delete Files for this record
        if (filesToBeDeleted.length > 0) {
          let deleteResponse = await this.DeleteAllFiles(filesToBeDeleted);
        }
        //Delete Investment items from the grid
        let deleteData = { Id: dataItem.Id };
        let items = { list: GridConfig, payload: deleteData };
        this.DeleteItem(items)
          .then(res => {
            //loader.hide();
            this.refreshGrid();
            this._AlertPopup("Deleted successfully!", "success");
          })
          .catch(error => {
            this._AlertPopup("Some Error Occurred!", "info");
          })
          .finally(() => {
            //loader.hide();
          });
      }
    },
    // Investment Documnet Dropoff
    InvestmentAttachment: function(e) {
      let self = this;
      e.preventDefault();
      const gview = window.$("#InvestmentGrid").data("kendoGrid");
      const dataItem = gview.dataItem(window.$(e.currentTarget).closest("tr"));

      this.selectedInvestment = { ...dataItem };
      //TEMP: Only for Transfer Page.. Building Partner Record for the Time Being
      (this.selectedInvestment.PartnerTitle = null),
        (this.selectedInvestment.PartnerId = null),
        (this.selectedInvestment.PartnerTitle = null),
        (this.selectedInvestment.PartnerId = null);
      this.selectedInvestment.TransactionID = dataItem.Id;
      this.selectedInvestment.BusinessEvent = "Investment";

      this.filterCondition.filter = `BusinessEvent eq 'Investment' and TransactionID eq ${dataItem.Id}`;

      this.$refs.investmentDocument.$refs.investmentDocumentMgr.resetDropZoneGrid();
      window.$("#docModal").modal("toggle");
    }
  }
};
</script>
